import { useTranslation } from 'react-i18next'
import { LangSwitchProps } from 'src/components/LangSwitch'
import { Localized } from 'src/rest/types/api/Common'
import { Configuration } from 'src/rest/types/Configuration'
import Router from 'src/routes/Router'

import { LinkProps } from '../../components/Link'

const useLangSwitch = <T>({
  currentLocale,
  localized,
}: {
  configuration: Configuration
  currentLocale: string
  localized: Array<Localized<T>>
}): LangSwitchProps | undefined => {
  const { t } = useTranslation()

  const links: LinkProps[] = localized.map((locale) => {
    return {
      label: locale.locale.toUpperCase(),
      title: locale.locale,
      href: Router.getRouteUrl(locale.type, {
        ...(locale.slug ? { slug: locale.slug } : {}),
        ...(locale.locale ? { lang: locale.locale } : {}),
      }),
      locale: locale.locale,
    }
  })
  links.push({
    label: currentLocale.toUpperCase(),
    'aria-current': true,
  })
  links.sort((a, b) => ((a.label ?? 0) > (b.label ?? 0) ? 1 : -1))

  return Array.isArray(localized)
    ? {
        button: {
          label: currentLocale.toUpperCase(),
          'aria-label': t('header.langSwitch.label'),
        },
        links: links ?? [],
      }
    : undefined
}

export default useLangSwitch
